import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, useMediaQuery } from '@mui/material';
import { Building, ClipboardExport, Document, Eye, Location, More2, User } from 'iconsax-react';
import { TableHeader } from '../../../../components/common/header/tableHeader/TableHeader';
import { SecondaryGrid } from '../../../../components/common/grid/SecondaryGrid';
import { palette } from '../../../../../theme/palette';
import { useAppSelector } from '@application/store/useStore';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { CustomChip } from '@ui/components/common/chip/Chip';
import { PlacementStatusMap } from '@application/common/enums/placement-status';
const theme = palette('light');
export const PlacementTable = ({ searchQuery }) => {
    const { placements } = useAppSelector((state) => state.placement);
    const navigate = useNavigate();
    const rows = useMemo(() => {
        return (placements || [])
            .filter((placementItem) => {
            const searchLower = searchQuery.toLowerCase();
            return (placementItem?.firstName?.toLowerCase().includes(searchLower) ||
                placementItem?.lastName?.toLowerCase().includes(searchLower) ||
                placementItem?.client?.toLowerCase().includes(searchLower) ||
                placementItem?.position?.toLowerCase().includes(searchLower) ||
                placementItem?.placementType?.toLowerCase().includes(searchLower));
        })
            .map((placement) => ({
            id: placement.id,
            freelancerName: `${placement.firstName} ${placement.lastName}`,
            client: placement.client,
            position: placement.position,
            employmentType: placement.placementType,
            status: placement.status,
            originalData: placement
        }));
    }, [searchQuery, placements]);
    const isXl = useMediaQuery('(max-width:1502px)');
    const columns = [
        {
            field: 'freelancerName',
            headerName: 'Freelancer Name',
            flex: isXl ? undefined : 1,
            width: isXl ? 140 : undefined,
            renderHeader: () => _jsx(TableHeader, { icon: User, text: ' Name' })
        },
        {
            field: 'client',
            headerName: 'Client',
            flex: isXl ? undefined : 1,
            width: isXl ? 140 : undefined,
            renderHeader: () => _jsx(TableHeader, { text: ' Client', icon: Building })
        },
        {
            field: 'position',
            headerName: 'Position',
            flex: isXl ? undefined : 1,
            width: isXl ? 140 : undefined,
            renderHeader: () => _jsx(TableHeader, { text: ' Position', icon: Document })
        },
        {
            field: 'employmentType',
            headerName: 'Employment Type',
            flex: isXl ? undefined : 1.5,
            width: isXl ? 150 : undefined,
            renderHeader: () => _jsx(TableHeader, { text: ' Employment Type', icon: Location })
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: isXl ? undefined : 1,
            width: isXl ? 140 : undefined,
            renderHeader: () => _jsx(TableHeader, { text: ' Status', icon: More2 }),
            renderCell: (params) => {
                return _jsx(CustomChip, { value: PlacementStatusMap.get(params.value) });
            }
        },
        {
            field: 'edit',
            headerName: 'Actions',
            headerAlign: 'left',
            align: 'left',
            flex: isXl ? undefined : 1,
            width: isXl ? 100 : undefined,
            renderHeader: () => _jsx(TableHeader, { text: 'Edit', icon: ClipboardExport }),
            renderCell: (params) => {
                return (_jsx(IconButton, { onClick: () => navigate('/edit-placements', { state: params.row.originalData }), children: _jsx(Eye, {}) }));
            }
        }
    ];
    return (_jsx("div", { children: _jsx(SecondaryGrid, { columns: columns, rows: rows }) }));
};
